import React, { useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
import AnnouncementSlider from "../Announcementslider";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

function Viewers({ prop }) {
  const location = useLocation();
  const stateValue = location.state && location.state["userPermissions"];
  const [dailyEntryData, setdailyEntryData] = useState([]);
  // console.log("State Value", stateValue);
  const [data, setData] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [isAuth, setIsAuth] = useState(false);
  const [isSuperuser, setIsSuperuser] = useState(false); // State to store superuser status
  const navigate = useNavigate();
  const [latestNews, setLatestNews] = useState(null);
  const [pipelineandturnedup, setPipelineandturnedup] = useState(null);
  const handleSignOut = () => {
    // For illustration purposes, let's clear the access token from localStorage
    localStorage.removeItem("access_token");

    // Redirect to the home page
    navigate("/");
  };

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      setIsAuth(true); // Set authentication status to true if access token is present
      fetch(getApiUrl("/Docladder/daily-user-records/", false), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          setData(data.records || []); // Update state with fetched data
          setdailyEntryData(data.monthly_records || []); // Update state with fetched data

          setIsSuperuser(data.is_superuser);
          setUserPermissions(data.user_permissions || []);
          setLatestNews(data.latest_news);
          setPipelineandturnedup(data.pipelineandturnedup || []);

          if (data.latest_news == "New News Updated") {
            navigate("/celebrationPage");
          }
        })
        .catch((error) => {});
    }
  }, []);

  const sortedData = useMemo(() => {
    if (!dailyEntryData || !pipelineandturnedup || !data) return [];

    return dailyEntryData
      .map((entry) => {
        const pipeline =
          pipelineandturnedup.find((item) => item.user === entry.user)
            ?.pipline || 0;

        const turnedUpRatio =
          entry.turned_up && pipeline
            ? ((entry.selected + entry.turned_up) / entry.resume_forwarded) *
              100
            : 0;

        // Get target revenue from data
        const correspondingRecord = data.find(
          (record) => record.id === entry.user
        );
        const targetRev = correspondingRecord ? correspondingRecord.revenue : 0;

        return {
          ...entry,
          pipeline,
          turnedUpRatio,
          targetRev, // Add target revenue for sorting
        };
      })
      .sort((a, b) => {
        // Move entries with targetRev === 0 to the bottom
        if (b.selected !== a.selected) return b.selected - a.selected;

        if (b.turnedUpRatio !== a.turnedUpRatio)
          return b.turnedUpRatio - a.turnedUpRatio;

        if (a.targetRev === 0 && b.targetRev !== 0) return 1;
        if (b.targetRev === 0 && a.targetRev !== 0) return -1;

        // Sort by revenue
        if (b.revenue !== a.revenue) return b.revenue - a.revenue;
        
        // Sort by resumes forwarded
        if (b.resume_forwarded !== a.resume_forwarded)
          return b.resume_forwarded - a.resume_forwarded;
        // Sort by pipeline
        return b.pipeline - a.pipeline;
      });
  }, [dailyEntryData, pipelineandturnedup, data]);

  // ############################ Iteration ########################################
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(4);
  const totalPages = Math.ceil((data && data.length) / recordsPerPage);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentViewers =
    sortedData && sortedData.slice(indexOfFirstRecord, indexOfLastRecord);
  const globalRecordCount = (currentPage - 1) * recordsPerPage;

  const paginate = () => {
    setCurrentPage((prevPage) => (prevPage === totalPages ? 1 : prevPage + 1));
  };

  useEffect(() => {
    if (data && data.length > 0) {
      const focusOnRecord = (index) => {
        setFocusedIndex(index);

        const timer = setTimeout(() => {
          const nextIndex = index + 1;

          if (nextIndex >= currentViewers.length) {
            if (currentPage < totalPages) {
              paginate();
              setFocusedIndex(0);
            } else {
              if (
                !isSuperuser &&
                !userPermissions.includes("website.see_records") &&
                !userPermissions.includes("website.update_target")
              ) {
                navigate("/docladderslider");
              }
            }
          } else {
            setFocusedIndex(nextIndex); // Focus on the next record
          }
        }, 2000);

        // Cleanup timer
        return () => clearTimeout(timer);
      };

      // Start focusing on the first record when the component mounts or data changes
      focusOnRecord(focusedIndex);

      // Reset focus index when the component unmounts
      return () => setFocusedIndex(0);
    }
  }, [
    focusedIndex,
    data,
    currentViewers,
    currentPage,
    totalPages,
    paginate,
    navigate,
    isSuperuser,
    userPermissions,
  ]);

  // ############################ Iteration ########################################

  return (
    <>
      <section>
        <div>
          <div>
            <div>
              <div>
                {/****************************** Viewer Code (Someone) ******************************/}
                <table
                  class="myTable min-w-full bg-white"
                  style={{ width: "95%", margin: "auto" }}
                >
                  <thead>
                    <tr>
                      {/* <th scope="col">Rank</th>  */}
                      <th scope="col" class="rankWidth">
                        Ranks
                      </th>
                      <th scope="col" class="hrWidth">
                        Image
                      </th>
                      <th scope="col" class="nameWidth">
                        Name
                      </th>
                      <th scope="col" class="resumeWidth">
                        Resume Forwarded
                      </th>
                      <th scope="col" class="pipWidth">
                        Pipeline
                      </th>
                      <th scope="col" class="turWidth">
                        Turned Up
                      </th>
                      <th scope="col" class="selWidth">
                        Selected Candidate
                      </th>
                      <th scope="col" class="selWidth">
                        Joined
                      </th>
                      <th scope="col" className="py-2 px-4 border-b">
                        Achievement Ratio
                        <Link
                          className="signOutLink"
                          to={{ pathname: "/" }}
                          onClick={handleSignOut}
                        >
                          <i class="fa-solid fa-right-from-bracket"></i>
                        </Link>
                      </th>
                      {!isSuperuser &&
                        userPermissions.includes("website.see_records") && (
                          <th className="col">Options</th>
                        )}
                    </tr>
                  </thead>

                  <tbody>
                    {/* {dailyEntryData && sortedData && */}
                    {sortedData &&
                      currentViewers.map((record, index) => {
                        // Calculate the actual index of the record in the entire dataset
                        const actualIndex = indexOfFirstRecord + index;

                        // Find the corresponding entry in pipelineandturnedup
                        const correspondingEntry = pipelineandturnedup.find(
                          (entry) => entry.user === record.user
                        );

                        const correspondingRecord = data.find(
                          (i) => i.id === record.user
                        );

                        // If a corresponding record is found, extract the image and name
                        const imageSrc = correspondingRecord
                          ? `${API_BASE_URL}${correspondingRecord.image}`
                          : "";
                        const userName = correspondingRecord
                          ? correspondingRecord.name
                          : "";

                        const targetRev = correspondingRecord
                          ? correspondingRecord.revenue
                          : "";

                        // If corresponding entry is found, extract the values
                        const pipeline = correspondingEntry
                          ? correspondingEntry.pipline
                          : "";
                        const turnedUp = correspondingEntry
                          ? correspondingEntry.turned_up
                          : "";

                        return (
                          <>
                            <tr
                              key={actualIndex}
                              className={`${
                                targetRev === 0
                                  ? index === focusedIndex
                                    ? "bg-red-400 text-black" // Show red only when active
                                    : "text-black"
                                  : (record.revenue / targetRev) * 100 <= 50
                                  ? index === focusedIndex
                                    ? "bg-red-400 text-black" // Light red background for active row
                                    : "text-black"
                                  : (record.revenue / targetRev) * 100 < 91
                                  ? index === focusedIndex
                                    ? "bg-yellow-400 text-black" // Light orange background for active row
                                    : "text-black"
                                  : (record.revenue / targetRev) * 100 <= 115
                                  ? index === focusedIndex
                                    ? "bg-green-200 text-black" // Light green background for active row
                                    : "text-black"
                                  : index === focusedIndex
                                  ? "bg-blue-200 text-black" // Light blue background for active row
                                  : "text-blue-500"
                              }`}
                              style={{
                                height: "10vh!important",
                                position: "relative",
                              }}
                            >
                              {/* Award Ranking */}
                              <td
                                style={{ textAlign: "center" }}
                                className="py-2 px-4 border-b text-center"
                              >
                                <div className="awards">
                                  <span
                                    className={`${
                                      index === focusedIndex
                                        ? "text-4xl font-bold  recordRanking award-content"
                                        : "text-xl recordRanking award-content"
                                    }`}
                                  >
                                    {globalRecordCount + index + 1}
                                  </span>
                                  <span className="image-content"></span>
                                </div>
                              </td>
                              {/* Image */}
                              <td className="py-2 px-4 border-b text-center">
                                {/* Display the image if available */}
                                {imageSrc && (
                                  <img
                                    src={imageSrc}
                                    className="w-auto"
                                    style={{ height: "100px" }}
                                    alt=""
                                  />
                                )}
                              </td>
                              <td className="py-2 px-4 border-b text-center">
                                {/* Display the user name if available */}
                                {userName && <span>{userName}</span>}
                                <br />
                              </td>
                              {/* Resume forwarded */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.resume_forwarded}
                              </td>
                              {/* Pipeline */}
                              <td className="py-2 px-4 border-b text-center">
                                {pipeline}
                              </td>
                              {/* Turned Up */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.turned_up}
                              </td>
                              {/* Selected */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.selected}
                              </td>
                              {/* Joined */}
                              <td className="py-2 px-4 border-b text-center">
                                {record.joined || 0}
                              </td>

                              <td className="py-2 px-4 border-b text-center">
                                {/* Calculate percentage here */}
                                <span
                                  // className={`${
                                  //   targetRev === 0
                                  //     ? "text-red-500" // Ensure text is red if targetRev is 0
                                  //     : (record.revenue / targetRev) * 100 <= 50
                                  //     ? "text-red-500"
                                  //     : (record.revenue / targetRev) * 100 < 91
                                  //     ? "text-yellow-500"
                                  //     : (record.revenue / targetRev) * 100 <=
                                  //       115
                                  //     ? "text-green-500"
                                  //     : "text-blue-500"
                                  // }`}
                                  style={{ fontSize: "1.2rem" }}
                                >
                                  {record.revenue !== 0 ? (
                                    <>
                                      {(
                                        (record.revenue / targetRev) *
                                        100
                                      ).toFixed(2)}
                                      %
                                    </>
                                  ) : (
                                    <span className="">0%</span>
                                  )}
                                </span>
                              </td>
                              {/* Edit Button */}
                              {!isSuperuser &&
                                userPermissions.includes(
                                  "website.see_records"
                                ) && (
                                  <td className="py-2 px-4 border-b text-center">
                                    <button className="btn btn-primary">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                                      </svg>
                                    </button>
                                  </td>
                                )}
                            </tr>
                          </>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <AnnouncementSlider />
      </section>
    </>
  );
}
export default Viewers;
